import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconSuzukaMinimapMarkers = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={376}
    height={375}
    fill="none"
    viewBox="0 0 376 375"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#icon-suzuka-minimap-markers_svg__a)">
      <path
        fill="url(#icon-suzuka-minimap-markers_svg__b)"
        fillOpacity={0.2}
        stroke="#fff"
        strokeOpacity={0.1}
        strokeWidth={10}
        d="M203.215 254.127c1.184 7.069-1.494 12.349-2.986 14.982-2.232 3.94-5.779 7.052-9.482 9.399-4.593 2.911-9.426 4.646-12.29 5.327 0 0-13.481 2.963-30.856 6.656-23.67 5.032-55.078 11.625-72.192 15.012-4.769.944-8.428 1.64-10.5 1.983-.918.152-1.525.235-1.778.24-4.378.083-5.835-.446-8.927-2.448-.887-.574-2.056-1.448-3.295-2.55-2.706-2.406-5.742-5.898-6.886-9.72-.722-2.415-.689-4.962.662-7.451 3.372-6.208 5.376-5.522 8.54-5.991.251-.037.582-.076.979-.117 2.998-.307 9.791-.703 15.205-1.102 2.877-.212 5.364-.425 6.685-.626 5.172-.785 8.787-1.488 11.768-7.259 1.656-3.206 2.27-4.517 2.882-5.494.482-.77 3.284-4.187 7.317-4.706 6.266-.805 6.561 1.212 16.89 2.984 9.037 1.551 13.654-8.311 14.577-10.283 2.026-4.326 2.52-5.97 6.422-8.42 6.585-4.135 11.746-2.58 16.165 1.884 2.157 2.676 6.982 9.15 10.466 11.738 4.485 3.331 10.565 3.253 15.69-.743 1.04-.81 2.089-1.597 3.138-2.432 2.348-1.869 4.696-3.986 6.938-7.171 2.215-2.939 3.751-6.357 5.456-9.999 1.78-3.802 1.433-7.694 1.645-14.437-.099-5.084-.848-7.825-1.894-11.511-1.189-3.241-2.867-7.6-4.532-11.864a2169.725 2169.725 0 0 0-3.916-9.942c-.926-2.336-1.62-4.079-1.891-4.767-.962-2.447-.775-3.308-.404-4.763a588.265 588.265 0 0 1 5.735-16.028c.992-2.634 1.858-4.824 2.389-5.958 1.419-3.03 4.345-2.408 7.702-1.042.856.349 1.74.746 2.634 1.143 1.784.792 3.795 1.501 5.717 2.115l22.038-22.339 22.966-23.233c4.949-5.384 17.616-18.03 27.715-24.77 7.383-4.93 12.451-8.309 18.202-11.444 4.081-2.225 8.506-4.328 14.347-6.773 1.82-.866 5.221-2.003 8.653-2.075 2.086-.043 4.183.308 5.943 1.352 5.821 3.454 5.742 7.595 5.973 10.413.186 2.274-1.93 13.551-6.828 17.561-1.838 1.505-3.582 2.011-5.588 2.068-2.654.075-5.767-.636-10.165-.859l-5.335-.433-10.042-.816c-6.016-.721-17.76 1.191-25.757 8.341-2.323 2.077-3.814 3.233-5.555 4.914-6.04 5.833-9.693 10.443-13.029 17.568-.901 1.925-1.399 3.362-2.152 5.257-.947 2.777-1.963 4.592-2.344 7.656-.421 3.378-.131 6.985.549 10.354a42.102 42.102 0 0 0 1.628 5.848c1.2 3.343 2.718 6.185 4.155 8.999 3.012 5.901 5.786 10.611 7.298 13.21.588.805 2.113 3.668 2.225 5.508.079 1.309-.375 2.123-1.351 2.885-1.098.856-2.488 1.011-3.77.108-.505-.355-1.53-1.389-2.722-3.123-1.356-1.971-5.098-7.767-8.633-11.421-1.032-1.067-2.047-1.951-2.979-2.504-2.165-1.285-9.035-3.744-15.521-5.935-5.866-1.982-11.418-3.744-12.889-4.219-1.405-.453-4.116-1.167-7.032-2.098l-.378.382c-2.155 2.215-3.294 3.579-4.28 5.502-1.474 2.874-1.821 5.454-2.1 7.132a66.621 66.621 0 0 0-.389 19.035c.475 3.893 1.249 7.75 2.312 12.058.754 3.054 1.654 6.334 2.697 10.013 2.239 7.903 3.464 13.355 4.157 17.12.825 4.487.894 6.578 1.022 7.565.188 1.452-.699 2.266-1.166 2.491-.63.241-2.161.849-4.265 1.826-1.455.676-2.072 1.116-2.445 2.905-.017 1.369.529 4.154 1.062 7.332Z"
      />
      <path
        stroke="#CCC"
        strokeWidth={4}
        d="M202.154 246.795c-.017 1.369.53 4.154 1.062 7.332 1.184 7.069-1.494 12.349-2.986 14.982-2.232 3.941-5.779 7.052-9.482 9.399"
      />
      <path
        stroke="#00FF2B"
        strokeWidth={4}
        d="M202.155 246.795c.373-1.789.99-2.229 2.445-2.905a69.493 69.493 0 0 1 4.264-1.826c.467-.225 1.355-1.039 1.167-2.491-.128-.987-.197-3.078-1.022-7.565"
      />
      <path
        stroke="#FFC107"
        strokeWidth={4}
        d="M209.008 232.008c-.693-3.765-1.918-9.217-4.157-17.12-1.043-3.679-1.943-6.959-2.697-10.013"
      />
      <path
        stroke="#FF5252"
        strokeWidth={4}
        d="M297.912 78.98c-5.751 3.135-10.819 6.515-18.203 11.444-10.099 6.74-22.766 19.386-27.715 24.77l-22.965 23.233-22.416 22.721c-2.156 2.215-3.294 3.579-4.281 5.502-1.474 2.874-1.821 5.454-2.099 7.132a66.549 66.549 0 0 0-.389 19.035c.474 3.893 1.248 7.75 2.312 12.058"
      />
      <path
        stroke="#CCC"
        strokeWidth={4}
        d="M320.912 70.133c-3.432.07-6.833 1.208-8.652 2.074-5.841 2.446-10.266 4.548-14.348 6.773"
      />
      <path
        stroke="#00FFE8"
        strokeWidth={4}
        d="M320.912 70.133c2.086-.044 4.183.307 5.943 1.351 5.822 3.454 5.742 7.596 5.973 10.413.186 2.274-1.929 13.551-6.828 17.561-1.838 1.505-3.582 2.011-5.588 2.068"
      />
      <path
        stroke="#FFC107"
        strokeWidth={4}
        d="M320.411 101.526c-2.655.076-5.768-.636-10.165-.859l-5.335-.433"
      />
      <path
        stroke="#FF5252"
        strokeWidth={4}
        d="m304.915 100.234-10.042-.816c-6.017-.721-17.76 1.191-25.757 8.341-2.323 2.077-3.814 3.233-5.555 4.914-6.04 5.833-9.693 10.443-13.029 17.568-.901 1.925-1.399 3.362-2.152 5.257-.948 2.777-1.963 4.592-2.345 7.656-.42 3.378-.131 6.985.55 10.354"
      />
      <path
        stroke="#CCC"
        strokeWidth={4}
        d="M259.661 181.565c-1.512-2.599-4.285-7.309-7.298-13.21-1.437-2.814-2.955-5.656-4.155-8.999a42.102 42.102 0 0 1-1.628-5.848"
      />
      <path
        stroke="#00FF2B"
        strokeWidth={4}
        d="M259.662 181.565c.588.806 2.113 3.668 2.225 5.508.08 1.309-.374 2.123-1.351 2.885-1.098.856-2.488 1.011-3.77.108-.505-.355-1.529-1.389-2.722-3.123"
      />
      <path
        stroke="#FFC107"
        strokeWidth={4}
        d="M254.045 186.943c-1.356-1.971-5.099-7.767-8.633-11.421"
      />
      <path
        stroke="#FF5252"
        strokeWidth={4}
        d="M245.412 175.522c-1.032-1.067-2.047-1.951-2.979-2.504-2.165-1.285-9.035-3.744-15.521-5.935"
      />
      <path
        stroke="#CCC"
        strokeWidth={4}
        d="M226.914 167.083c-5.867-1.982-11.418-3.744-12.889-4.219-2.331-.752-8.259-2.219-12.749-4.213-.895-.398-1.779-.794-2.635-1.143"
      />
      <path
        stroke="#00FF2B"
        strokeWidth={4}
        d="M198.73 157.5c-3.357-1.366-6.283-1.988-7.702 1.041-.531 1.135-1.397 3.324-2.389 5.959"
      />
      <path
        stroke="#FFC107"
        strokeWidth={4}
        d="M188.639 164.5a580.204 580.204 0 0 0-4.342 12"
      />
      <path
        stroke="#00FFE8"
        strokeWidth={4}
        d="M184.295 176.5a474.536 474.536 0 0 0-1.393 4.027c-.371 1.455-.557 2.316.405 4.764.27.688.964 2.431 1.89 4.767"
      />
      <path
        stroke="#FFC107"
        strokeWidth={4}
        d="M185.197 190.058c1.089 2.745 2.498 6.309 3.916 9.942"
      />
      <path
        stroke="#FF5252"
        strokeWidth={4}
        d="M189.115 200c1.665 4.264 3.344 8.623 4.532 11.864 1.046 3.686 1.796 6.426 1.895 11.511-.213 6.743.134 10.635-1.646 14.437-1.705 3.642-3.24 7.06-5.456 9.998-2.241 3.186-4.59 5.302-6.937 7.172"
      />
      <path
        stroke="#00FFE8"
        strokeWidth={4}
        d="M162.675 258.157c4.484 3.331 10.565 3.252 15.69-.743 1.04-.811 2.089-1.597 3.138-2.432"
      />
      <path
        stroke="#CCC"
        strokeWidth={4}
        d="M162.675 258.157c-3.484-2.588-8.309-9.063-10.466-11.738"
      />
      <path
        stroke="#00FFE8"
        strokeWidth={4}
        d="M152.209 246.419c-4.419-4.465-9.58-6.019-16.165-1.884-3.902 2.45-4.396 4.093-6.422 8.42-.923 1.971-5.54 11.833-14.578 10.283-10.328-1.772-10.623-3.79-16.89-2.984-4.032.519-6.834 3.936-7.316 4.706-.613.977-1.227 2.288-2.883 5.494-2.98 5.77-6.595 6.474-11.767 7.259"
      />
      <path
        stroke="#FF5252"
        strokeWidth={4}
        d="M76.188 277.713c-1.321.2-3.808.413-6.685.625"
      />
      <path
        stroke="#CCC"
        strokeWidth={4}
        d="M69.502 278.338c-5.414.4-12.208.796-15.206 1.103"
      />
      <path
        stroke="#00FFE8"
        strokeWidth={4}
        d="M54.299 279.441c-.397.04-.728.08-.98.117-3.163.468-5.167-.218-8.539 5.991-1.351 2.488-1.385 5.035-.662 7.451"
      />
      <path
        stroke="#CCC"
        strokeWidth={4}
        d="M44.115 293c1.144 3.822 4.18 7.313 6.886 9.72"
      />
      <path
        stroke="#00FFE8"
        strokeWidth={4}
        d="M51.003 302.72c1.239 1.101 2.408 1.975 3.294 2.549 3.092 2.002 4.55 2.532 8.927 2.449.254-.005.86-.088 1.779-.24"
      />
      <path
        stroke="#FFC107"
        strokeWidth={4}
        d="M65 307.478c2.073-.344 5.732-1.039 10.5-1.983"
      />
      <path
        stroke="#FF5252"
        strokeWidth={4}
        d="M75.502 305.495c17.113-3.388 48.522-9.98 72.191-15.012 17.375-3.694 30.857-6.656 30.857-6.656 2.864-.681 7.697-2.416 12.289-5.327"
      />
      <g filter="url(#icon-suzuka-minimap-markers_svg__c)">
        <path
          fill="#fff"
          fillOpacity={0.95}
          d="m129.019 273.756 3.931-.878.987 4.417-3.932.878zM130.991 282.59l3.931-.878.987 4.417-3.932.878zM132.964 291.424l3.931-.878.987 4.417-3.932.878zM134.937 300.258l3.931-.878.987 4.417-3.932.878zM136.909 309.092l3.931-.878.987 4.417-3.932.878zM133.937 277.295l3.931-.878.987 4.417-3.932.878zM135.909 286.129l3.931-.878.987 4.417-3.932.878zM137.882 294.963l3.931-.878.987 4.417-3.932.878z"
        />
        <path
          fill="#fff"
          fillOpacity={0.95}
          d="m139.854 303.797 3.931-.878.987 4.417-3.932.878z"
        />
        <path
          fill="#000"
          d="m132.95 272.878 3.931-.878.987 4.417-3.932.878zM134.923 281.712l3.931-.878.987 4.417-3.932.878zM136.896 290.546l3.931-.878.987 4.417-3.932.878zM138.868 299.38l3.931-.878.987 4.417-3.932.878zM140.841 308.214l3.931-.878.987 4.417-3.932.878zM130.005 278.173l3.931-.878.987 4.417-3.932.878z"
        />
        <path
          fill="#000"
          d="m131.978 287.007 3.931-.878.987 4.417-3.932.878zM133.95 295.841l3.931-.878.987 4.417-3.932.878zM135.923 304.675l3.931-.878.987 4.417-3.932.878z"
        />
        <path
          fill="#E2645A"
          d="m113.817 324.675 16.612 6.389-4.307-19.286-12.305 12.897Zm-2.209.493c-.159-.711-.015-1.439.484-1.949l12.918-13.481c.987-1.066 2.658-.444 3.007 1.12l4.529 20.281c.338 1.516-.898 2.837-2.235 2.339l-17.436-6.752a2.209 2.209 0 0 1-1.267-1.558Z"
        />
      </g>
      <g filter="url(#icon-suzuka-minimap-markers_svg__d)">
        <rect
          width={20}
          height={20}
          x={338.5}
          y={64}
          fill="url(#icon-suzuka-minimap-markers_svg__e)"
          rx={10}
        />
        <g filter="url(#icon-suzuka-minimap-markers_svg__f)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m344.634 71.076-1.836.948V70.74l2.076-1.14h1.152V78h-1.392v-6.924Zm3.022 5.688v-1.188h1.392v.768l.468.456h2.28l.468-.456V74.82l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L352.42 78h-3.528l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-suzuka-minimap-markers_svg__g)">
        <rect
          width={20}
          height={20}
          x={256.5}
          y={138}
          fill="url(#icon-suzuka-minimap-markers_svg__h)"
          rx={10}
        />
        <g filter="url(#icon-suzuka-minimap-markers_svg__i)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m262.803 145.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.071 5.16 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V152h-5.784v-1.764Z"
          />
        </g>
      </g>
      <g filter="url(#icon-suzuka-minimap-markers_svg__j)">
        <rect
          width={20}
          height={20}
          x={262.5}
          y={195}
          fill="url(#icon-suzuka-minimap-markers_svg__k)"
          rx={10}
        />
        <g filter="url(#icon-suzuka-minimap-markers_svg__l)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m269.958 202.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm4.738 0-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
          />
        </g>
      </g>
      <g filter="url(#icon-suzuka-minimap-markers_svg__m)">
        <rect
          width={20}
          height={20}
          x={221.5}
          y={177}
          fill="url(#icon-suzuka-minimap-markers_svg__n)"
          rx={10}
        />
        <g filter="url(#icon-suzuka-minimap-markers_svg__o)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m227.341 184.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.262 5.592v-5.736l1.332-1.332h3.624l1.332 1.332v5.736L235.559 191h-3.624l-1.332-1.332Zm4.308.132.588-.576v-4.848l-.588-.576h-2.328l-.588.576v4.848l.588.576h2.328Z"
          />
        </g>
      </g>
      <g filter="url(#icon-suzuka-minimap-markers_svg__p)">
        <rect
          width={20}
          height={20}
          x={174.5}
          y={132}
          fill="url(#icon-suzuka-minimap-markers_svg__q)"
          rx={10}
        />
        <g filter="url(#icon-suzuka-minimap-markers_svg__r)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M181.44 144.764v-1.02h1.392v.576l.48.48h2.184l.48-.48v-2.172l-.744.744h-2.676l-1.236-1.236v-2.82l1.236-1.236h3.576l1.236 1.236v5.928L186.132 146h-3.456l-1.236-1.236Zm3.648-3.072.888-.888v-1.524l-.48-.48h-2.304l-.48.48v1.932l.48.48h1.896Z"
          />
        </g>
      </g>
      <g filter="url(#icon-suzuka-minimap-markers_svg__s)">
        <rect
          width={20}
          height={20}
          x={156.5}
          y={167}
          fill="url(#icon-suzuka-minimap-markers_svg__t)"
          rx={10}
        />
        <g filter="url(#icon-suzuka-minimap-markers_svg__u)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M163.256 179.764v-2.34l.756-.756-.636-.636v-2.196l1.236-1.236h3.528l1.236 1.236v2.196l-.636.636.756.756v2.34L168.26 181h-3.768l-1.236-1.236Zm4.248-3.612.48-.48v-1.392l-.48-.48h-2.256l-.48.48v1.392l.48.48h2.256Zm.12 3.648.48-.48v-1.524l-.48-.468h-2.496l-.48.468v1.524l.48.48h2.496Z"
          />
        </g>
      </g>
      <g filter="url(#icon-suzuka-minimap-markers_svg__v)">
        <rect
          width={20}
          height={20}
          x={157.5}
          y={228}
          fill="url(#icon-suzuka-minimap-markers_svg__w)"
          rx={10}
        />
        <g filter="url(#icon-suzuka-minimap-markers_svg__x)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M168.661 235.028v-.228h-4.248v-1.2h5.688v1.464L166.753 242h-1.464l3.372-6.972Z"
          />
        </g>
      </g>
      <g filter="url(#icon-suzuka-minimap-markers_svg__y)">
        <rect
          width={20}
          height={20}
          x={130.5}
          y={212}
          fill="url(#icon-suzuka-minimap-markers_svg__z)"
          rx={10}
        />
        <g filter="url(#icon-suzuka-minimap-markers_svg__A)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M137.409 224.764v-5.928l1.236-1.236h3.528l1.236 1.236v1.104h-1.392v-.66l-.48-.48h-2.256l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772L142.221 226h-3.576l-1.236-1.236Zm4.176.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.304Z"
          />
        </g>
      </g>
      <g filter="url(#icon-suzuka-minimap-markers_svg__B)">
        <rect
          width={20}
          height={20}
          x={106.5}
          y={232}
          fill="url(#icon-suzuka-minimap-markers_svg__C)"
          rx={10}
        />
        <g filter="url(#icon-suzuka-minimap-markers_svg__D)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M113.389 244.764v-1.224h1.392v.804l.468.456h2.256l.468-.456v-2.064l-.468-.468h-3.996V237.6h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904L118.129 246h-3.504l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-suzuka-minimap-markers_svg__E)">
        <rect
          width={20}
          height={20}
          x={84.5}
          y={228}
          fill="url(#icon-suzuka-minimap-markers_svg__F)"
          rx={10}
        />
        <g filter="url(#icon-suzuka-minimap-markers_svg__G)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M95.207 240.392h-4.08v-1.572l3.684-5.22H96.6v5.592h1.02v1.2H96.6V242h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
          />
        </g>
      </g>
      <g filter="url(#icon-suzuka-minimap-markers_svg__H)">
        <rect
          width={20}
          height={20}
          x={30.5}
          y={252}
          fill="url(#icon-suzuka-minimap-markers_svg__I)"
          rx={10}
        />
        <g filter="url(#icon-suzuka-minimap-markers_svg__J)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m37.505 264.236 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V266h-5.784v-1.764Z"
          />
        </g>
      </g>
      <g filter="url(#icon-suzuka-minimap-markers_svg__K)">
        <rect
          width={20}
          height={20}
          x={64.5}
          y={242}
          fill="url(#icon-suzuka-minimap-markers_svg__L)"
          rx={10}
        />
        <g filter="url(#icon-suzuka-minimap-markers_svg__M)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M71.287 254.764v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L76.05 256h-3.528l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-suzuka-minimap-markers_svg__N)">
        <rect
          width={20}
          height={20}
          x={37.5}
          y={312}
          fill="url(#icon-suzuka-minimap-markers_svg__O)"
          rx={10}
        />
        <g filter="url(#icon-suzuka-minimap-markers_svg__P)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m47.327 319.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="icon-suzuka-minimap-markers_svg__c"
        width={70.203}
        height={87.322}
        x={90.5}
        y={265}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={3}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={4} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__d"
        width={36}
        height={36}
        x={330.5}
        y={58}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__f"
        width={26.858}
        height={24.4}
        x={334.798}
        y={63.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__g"
        width={36}
        height={36}
        x={248.5}
        y={132}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__i"
        width={26.689}
        height={24.4}
        x={252.968}
        y={137.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__j"
        width={36}
        height={36}
        x={254.5}
        y={189}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__l"
        width={23.966}
        height={24.4}
        x={260.122}
        y={194.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__m"
        width={36}
        height={36}
        x={213.5}
        y={171}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__o"
        width={27.386}
        height={24.4}
        x={217.505}
        y={176.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__p"
        width={36}
        height={36}
        x={166.5}
        y={126}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__r"
        width={22.048}
        height={24.4}
        x={173.32}
        y={131.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__s"
        width={36}
        height={36}
        x={148.5}
        y={161}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__u"
        width={22.24}
        height={24.4}
        x={155.256}
        y={166.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__v"
        width={36}
        height={36}
        x={149.5}
        y={222}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__x"
        width={21.688}
        height={24.4}
        x={156.413}
        y={227.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__y"
        width={36}
        height={36}
        x={122.5}
        y={206}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__A"
        width={22.048}
        height={24.4}
        x={129.409}
        y={211.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__B"
        width={36}
        height={36}
        x={98.5}
        y={226}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__D"
        width={21.977}
        height={24.4}
        x={105.389}
        y={231.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__E"
        width={36}
        height={36}
        x={76.5}
        y={222}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__G"
        width={22.492}
        height={24.4}
        x={83.127}
        y={227.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__H"
        width={36}
        height={36}
        x={22.5}
        y={246}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__J"
        width={21.831}
        height={24.4}
        x={29.457}
        y={251.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__K"
        width={36}
        height={36}
        x={56.5}
        y={236}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__M"
        width={22}
        height={24.4}
        x={63.287}
        y={241.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__N"
        width={36}
        height={36}
        x={29.5}
        y={306}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <filter
        id="icon-suzuka-minimap-markers_svg__P"
        width={19.227}
        height={24.4}
        x={37.491}
        y={311.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24529"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24529"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24529"
          result="effect2_dropShadow_9632_24529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24529"
          result="shape"
        />
      </filter>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__b"
        x1={111.273}
        x2={271.594}
        y1={143.298}
        y2={218.361}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4FC5BA" />
        <stop offset={1} stopColor="#4FC5BA" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__e"
        x1={358.5}
        x2={338.5}
        y1={64}
        y2={84}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__h"
        x1={276.5}
        x2={256.5}
        y1={138}
        y2={158}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__k"
        x1={282.5}
        x2={262.5}
        y1={195}
        y2={215}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__n"
        x1={241.5}
        x2={221.5}
        y1={177}
        y2={197}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__q"
        x1={194.5}
        x2={174.5}
        y1={132}
        y2={152}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__t"
        x1={176.5}
        x2={156.5}
        y1={167}
        y2={187}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__w"
        x1={177.5}
        x2={157.5}
        y1={228}
        y2={248}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__z"
        x1={150.5}
        x2={130.5}
        y1={212}
        y2={232}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__C"
        x1={126.5}
        x2={106.5}
        y1={232}
        y2={252}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__F"
        x1={104.5}
        x2={84.5}
        y1={228}
        y2={248}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__I"
        x1={50.5}
        x2={30.5}
        y1={252}
        y2={272}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__L"
        x1={84.5}
        x2={64.5}
        y1={242}
        y2={262}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-suzuka-minimap-markers_svg__O"
        x1={57.5}
        x2={37.5}
        y1={312}
        y2={332}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <clipPath id="icon-suzuka-minimap-markers_svg__a">
        <path fill="#fff" d="M.5 0h375v375H.5z" />
      </clipPath>
    </defs>
  </svg>
));
export default SvgIconSuzukaMinimapMarkers;
